import * as React from "react";

function Sort(props) {
  return (
    <svg width="1em" height="1em" viewBox="0 0 8 10" fill="none" {...props}>
      <path d="M0 4.5l4-4 4 4H0zM8 5.5l-4 4-4-4h8z" fill="var(--color-blue-500)" />
    </svg>
  );
}

export default Sort;
